"use client";

import { Button } from '@/components/Button/Button';
import useCartStore from '@/store/useCartStore';
import { CartTicket } from '@/types/CartType';
import { formatPrice } from '@/utils/pricingUtils';
import { CartQuantityPicker } from '../CartQuantityPicker/CartQuantityPicker';
import styles from './CartListItem.module.scss';

type CartListItemProps = {
  tickets: CartTicket[];
}

export function CartListItem({ tickets }: CartListItemProps) {

  const setCartQty = useCartStore(state => state.setTicketQty);
  const cartLoading = useCartStore(state => state.cartLoading);
  const removeAllFromCart = useCartStore(state => state.removeAllFromCart);

  const firstTicket = tickets[0]

  const qtyPickers: Array<JSX.Element> = []

  // TODO: Add images Where are they coming from?

  for (const ticket of tickets) {
    qtyPickers.push(<CartQuantityPicker key={ ticket.cart_item_id } ticketPrice={ ticket.price } showTicketPrice={false} showTotalPrice={true} qty={ ticket.qty } setQty={(qty: number) => setCartQty(ticket.cart_item_id, qty)} loading={cartLoading ?? false} leftText={ ticket.data?.type_ticket ?? '' } leftSubText={ `£${formatPrice(ticket.price)} per ticket`} year={ticket.year} date ={ticket.date} />)
  }

  const removeLink = <Button loading={cartLoading} className={styles.remove} onClick={() => removeAllFromCart(tickets.map(t => t.ticket_id), firstTicket.date)}>Remove</Button>

  return (
    <div className={styles.cartListItem}>
      <div className={styles.info}>
        <h2>{ firstTicket.title }</h2>
      </div>
      <div className={styles.qty}>
        { qtyPickers }
      </div>
      { removeLink }
    </div>
  )
}
